import { useQuery } from "@tanstack/react-query";

import { purchaseOrderService } from "~/services/purchasing";

const QUERY_KEY = "misc_descriptions";

// Distinct descriptions from past Misceláneos ("misc") PO lines, used to
// populate the creatable combobox. No master/catalog table involved.
export function useMiscDescriptions() {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => purchaseOrderService.getMiscDescriptions(),
  });
}
